<template>
    <div class="report-page marriage-report-page" :class="marriageData.is_pay == 0 ? 'marriage-report-page2' : ''">
        <div class="my-report-top-bar marriage-report-top-bar">
            <div class="report-title-bar marriage-title-bar marriage-report-title-bar dsp-flex">
                <div class="report-title-side">
                    <span class="report-title-back" @click="clickBack"><i class="iconfont icon-xiangzuo"></i></span>
                </div>
                <div class="report-title-mid" v-if="marriageFavorableInfoData && marriageFavorableInfoData.infoMale && marriageFavorableInfoData.infoFemale"><span>{{ marriageFavorableInfoData.infoMale.name+'和'+marriageFavorableInfoData.infoFemale.name+'的' }}姻缘测算报告</span></div>
                <div class="report-title-side">
                </div>
            </div>
            <!-- 1、顶部标题栏部分 -->
            <div class="marriage-report-top-tab">
                <span v-for="tab in tabList" :key="tab.id" class="marriage-report-top-tab-item" v-bind:class="['tab-two' + tab.id]" @click="clickTab(tab.id)"><span class="on" v-if="curTab == tab.id"></span></span>
            </div>
        </div>
        <!-- 2、结果部分 -->
        <marriage-report-two-result></marriage-report-two-result>
        <!-- 3、vip解锁按钮 -->
        <marriage-bottom-button v-if="marriageData.is_pay == 0" :clickFunc="clickBottomButton"></marriage-bottom-button>
        
        <router-view></router-view>
    </div>
</template>

<script>
import { MIX, UA } from '../../modules/utils';
import { CONFIG } from '../../modules/config';
import { MARRIAGE_DOM } from '../../modules/dom';
import MarriageReportTwoResult from '../../layouts/marriage/MarriageReportTwoResult.vue';
import MarriageBottomButton from '../../layouts/marriage/MarriageBottomButton.vue';
import { SHARE } from '../../modules/share';
export default {
    name: 'MarriageReportOne',
    components: { MarriageReportTwoResult, MarriageBottomButton },
    computed: {
        userData() {
            return this.$store.state.userData ? this.$store.state.userData.info : {};
        },
        marriageProductData() {
            return this.$store.state.pay.marriageProductData;
        },
        marriageData() {
            return this.$store.state.marriage.marriageData;
        },
        marriageFavorableInfoData() {
            return this.$store.state.marriage.marriageFavorableInfoData;
        },
        productData() {
            return this.$store.state.pay.marriageProductData[this.$store.state.marriage.marriageData.pid];
        },
    },
    data() {
        return {
            showTips: window.localStorage.getItem('h5_fate_ds_year_tips') ? false : true,
            qrCode: require('../../assets/images/report/report-code.png'),
            curTab: 1,
            tabList: [
                {id: 1, text: '二人缘分综合得分'},
                {id: 2, text: '双方生日能量评测'},
                {id: 3, text: '各自的婚姻观'},
                {id: 4, text: '各自夫妻星的稳定性'},
                {id: 5, text: '各自夫妻宫的稳定性'},
                {id: 6, text: '相处方式和谐度'},
                {id: 7, text: '夫妻宫的匹配度'},
                {id: 8, text: '整体生日能量契合度'},
                {id: 9, text: '月老送上天长地久建议'},
                {id: 10, text: '未来12个月感情危机规避'},
            ]
        }
    },
    mounted() {
        this.$bus.on('updateMarriageReportTab', this.updateMarriageReportTab);
        let curPath = this.$router.history.current.path;
        let time = curPath.indexOf('share') == -1 ? 20 : 1500;
        setTimeout(() => {
            window.scrollTo(0, 0);
            this.initDom();
            if(!this.marriageData.id && curPath.indexOf('share') == -1) {
                this.$router.replace({ path: '/marriagerecord' });
                return;
            }
            SHARE.initConfigShare();
        }, time);
    },
    destroyed() {
        this.$bus.off('updateMarriageReportTab', this.updateMarriageReportTab);
    },
    methods: {
        initDom() {
            MARRIAGE_DOM.initMarriagePageHeightList();
            setTimeout(() => {
                MARRIAGE_DOM.bindMarriageScrollEvent();
            }, 20);
        },
        clickBack() {
            this.$store.dispatch('marriage/resetMarriageData');
            this.$router.replace({ path: '/marriagerecord' });
        },
        clickTab(tabId) {
            this.curTab = tabId;
            console.log('clickTopTab-----', tabId)
            MARRIAGE_DOM.updateMarriageScrollTopByTab(tabId);
        },
        updateMarriageReportTab(tabId) {
            if(tabId == this.curTab) {
                return;
            }
            this.curTab = tabId;
        },
        clickBottomButton() {
            this.$bus.emit('triggerReportTwoPay');
        }
    }
}
</script>